import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import type { Gruppe } from '@uep/shared';
import { Ladeflaeche } from '@/components/ui';
import { useAuth } from './AuthKontext';

/**
 * Geschütztes Routing (PHASENPLAN 0.7).
 *
 * Ohne Anmeldung gibt es keine Seite zu sehen. Die Rollenprüfung blendet
 * Bereiche aus, die eine Rolle ohnehin nicht bedienen darf — verbindlich
 * durchgesetzt wird sie serverseitig über Cognito-Gruppen.
 */
export const Rollenschutz = ({ children, rolle }: { children: ReactNode; rolle?: Gruppe }) => {
  const { schritt, hatRolle } = useAuth();
  const ort = useLocation();

  if (schritt === 'laedt') return <Ladeflaeche text="Anmeldung wird geprüft …" />;

  if (schritt !== 'angemeldet') {
    return <Navigate to="/anmelden" replace state={{ von: ort.pathname }} />;
  }

  if (rolle && !hatRolle(rolle)) {
    return <Navigate to="/kein-zugriff" replace />;
  }

  return <>{children}</>;
};

/** Blendet Kinder nur für eine bestimmte Rolle ein. */
export const NurFuer = ({ rolle, children }: { rolle: Gruppe; children: ReactNode }) => {
  const { hatRolle } = useAuth();
  return hatRolle(rolle) ? <>{children}</> : null;
};
